module.exports = __webpack_public_path__ + "static/media/Danone_Bold.efe130d3.woff2";